// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div id="customer-deposit-accounts-check-withdrawal" class="box product-operation">
  <sub-header header="'Withdraw check from account'"></sub-header>

  <span ng-if="\$ctrl.micrUnsupportedBySelectedDepositoryAccount"
        class="alert alert--danger">
    Provided MICR number is not supported by selected Check account.
  </span>

    <!-- Product information -->
    <!-- TODO = this should be extracted as component -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">
          {{\$ctrl.depositAccount.productName}}
        </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
          {{\$ctrl.depositAccount.balance | nxCurrency}}
        </span>
      </div>
    </div>

    <br/>

    <!-- Operation form -->

    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">

        <tbody>
        <tr>
          <td>1.</td>
          <td>MICR number</td>
          <td>
            <input
              required
              type="text"
              class="check-no"
              ng-model="\$ctrl.micrNumber"
              ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"
              ui-mask-placeholder
              ui-options="{clearOnBlur: false}"
              ng-change="\$ctrl.onMicrNumberChange(\$ctrl.micrNumber)"
              ng-class="{'nx-invalid': \$ctrl.micrUnsupportedBySelectedDepositoryAccount}"
              maxlength="64"/>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Valid from</td>
          <td>
            <date ng-model="\$ctrl.validFrom"
            output-format="date"
              ng-required="true"></date>
          </td>
        </tr>
        <tr>
          <td>3.</td>
          <td>Check account</td>
          <td>
            <selectize options="\$ctrl.checkingAccounts"
                       config="\$ctrl.selectConfig"
                       ng-model="\$ctrl.checkingAccountId"
                       ng-change="\$ctrl.onCheckingAccountChange()"
                       ng-required="true">
            </selectize>
          </td>
        </tr>
        <tr>
          <td>4.</td>
          <td>Amount</td>
          <td>
            <cash ng-model="\$ctrl.amount"
              ng-required="true"></cash>
          </td>
        </tr>
        <tr>
          <td>5.</td>
          <td>Remarks</td>
          <td>
            <input type="text"
                   ng-model="\$ctrl.remarks"
                   ng-required="false">
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <signature-card
          file-id="\$ctrl.depositAccount.signatureCardFileId"
          product-group="'ACCOUNT'"
          product-status="\$ctrl.depositAccount.status"></signature-card>
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-danger"
                ng-click="\$ctrl.withdraw()"
                ng-disabled="!\$ctrl.amount || !\$ctrl.checkingAccountId || !\$ctrl.checkNo || \$ctrl.micrUnsupportedBySelectedDepositoryAccount">
          Withdraw
        </button>
      </div>
    </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/check-withdrawal/check-withdrawal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;